import * as Yup from 'yup';

export const DevolucaoValidationSchema = Yup.object().shape({
	id: Yup.number().nullable().min(1, 'Campo obrigatório').required('Campo obrigatório'),
	quantidadeDevolucao: Yup.number().min(1, 'Quantidade não deve ser inferior a 1')
		.required('Campo obrigatório'),

});
